var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios from "axios";
import { BAlert, BButton, BCard, BCardGroup, BFormSelect, BFormSelectOption, BListGroup, BListGroupItem, BModal, } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import Multiselect from "vue-multiselect";
import { useConfig } from "@/composables/config";
import { getAppRoot } from "@/onload";
import { useUserStore } from "@/stores/userStore";
import { assertArray } from "@/utils/assertions";
import Heading from "../Common/Heading.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserSharing',
    props: {
        item: null,
        modelClass: null
    },
    emits: ["share", "error", "cancel"],
    setup(__props, { expose, emit }) {
        var _a;
        const props = __props;
        const { currentUser } = storeToRefs(useUserStore());
        const { config, isConfigLoaded } = useConfig(false);
        const permissionsChangeRequired = computed(() => {
            if (props.item.extra) {
                return props.item.extra.can_change.length > 0 || props.item.extra.cannot_change.length > 0;
            }
            else {
                return false;
            }
        });
        const userIsAdmin = computed(() => currentUser.value && "is_admin" in currentUser.value && currentUser.value.is_admin);
        const exposeEmails = computed(() => config.value.expose_user_email || userIsAdmin.value);
        const sharingCandidates = ref([...((_a = props.item.users_shared_with) !== null && _a !== void 0 ? _a : [])]);
        const sharingCandidatesAsEmails = computed(() => sharingCandidates.value.map(({ email }) => email));
        function reset() {
            var _a;
            sharingCandidates.value = [...((_a = props.item.users_shared_with) !== null && _a !== void 0 ? _a : [])];
        }
        const userOptions = ref([]);
        const currentSearch = ref("");
        function onSearchChanged(searchValue) {
            return __awaiter(this, void 0, void 0, function* () {
                currentSearch.value = searchValue;
                if (!exposeEmails.value) {
                    userOptions.value = [{ email: searchValue }];
                }
                else if (searchValue.length < 3) {
                    userOptions.value = [];
                }
                else {
                    try {
                        const response = yield axios.get(`${getAppRoot()}api/users?f_email=${searchValue}`);
                        const data = response.data;
                        assertArray(data);
                        userOptions.value = data.filter((value) => value &&
                            typeof value === "object" &&
                            "email" in value &&
                            typeof value.email === "string" &&
                            !sharingCandidatesAsEmails.value.includes(value.email));
                    }
                    catch (e) {
                        emit("error", e);
                    }
                }
            });
        }
        function onBlur() {
            const isValueChosen = sharingCandidates.value.some(({ email }) => email === currentSearch.value);
            if (currentSearch.value && !exposeEmails.value && !isValueChosen) {
                sharingCandidates.value.push({ email: currentSearch.value });
            }
        }
        function onRemove(user) {
            const index = sharingCandidates.value.indexOf(user);
            if (index >= 0) {
                sharingCandidates.value.splice(index, 1);
            }
        }
        const charactersThresholdWarning = "Enter at least 3 characters to see suggestions";
        const elementsNotFoundWarning = "No elements found. Consider changing the search query";
        function onCancel() {
            var _a;
            sharingCandidates.value = [...((_a = props.item.users_shared_with) !== null && _a !== void 0 ? _a : [])];
            emit("cancel");
        }
        function onSubmit() {
            emit("share", sharingCandidatesAsEmails.value);
        }
        const noChanges = computed(() => {
            var _a;
            const candidates = [...sharingCandidatesAsEmails.value];
            const sharedWith = [...((_a = props.item.users_shared_with) !== null && _a !== void 0 ? _a : []).map(({ email }) => email)];
            const newCandidates = candidates.filter((email) => !sharedWith.includes(email));
            const removedShared = sharedWith.filter((email) => !candidates.includes(email));
            return !(newCandidates.length !== 0 || removedShared.length !== 0);
        });
        const canChangeCount = computed(() => { var _a, _b; return (_b = (_a = props.item.extra) === null || _a === void 0 ? void 0 : _a.can_change.length) !== null && _b !== void 0 ? _b : 0; });
        const cannotChangeCount = computed(() => { var _a, _b; return (_b = (_a = props.item.extra) === null || _a === void 0 ? void 0 : _a.cannot_change.length) !== null && _b !== void 0 ? _b : 0; });
        const selectedSharingOption = ref("make_public");
        function onUpdatePermissions() {
            emit("share", sharingCandidatesAsEmails.value, selectedSharingOption.value);
        }
        expose({
            reset,
        });
        return { __sfc: true, props, emit, currentUser, config, isConfigLoaded, permissionsChangeRequired, userIsAdmin, exposeEmails, sharingCandidates, sharingCandidatesAsEmails, reset, userOptions, currentSearch, onSearchChanged, onBlur, onRemove, charactersThresholdWarning, elementsNotFoundWarning, onCancel, onSubmit, noChanges, canChangeCount, cannotChangeCount, selectedSharingOption, onUpdatePermissions, BAlert, BButton, BCard, BCardGroup, BFormSelect, BFormSelectOption, BListGroup, BListGroupItem, BModal, Multiselect, Heading };
    }
});
